import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Close } from "@remo-co/ui-core/src/icons/Close";
import { useI18n } from "i18n";
import { useStyles } from "./DialogHeader.styles";
import BuildingIcon from "../../assets/building.svg";

interface IDialogHeaderProps {
  handleClose: () => void;
  isEditMode?: boolean;
}

const DialogHeader = ({ handleClose, isEditMode }: IDialogHeaderProps) => {
  const styles = useStyles();
  const { t } = useI18n(["eventDirectory"]);

  return (
    <Container className={styles.header}>
      <Container className={styles.headerLeft} fullWidth={false}>
        <Container className={styles.container}>
          <Container className={styles.iconContainer}>
            <img
              className={styles.icon}
              src={BuildingIcon}
              alt={t("eventDirectory:section.title")}
            />
          </Container>
          <Typography variant="h3" className={styles.headerText}>
            {isEditMode
              ? t("eventDirectory:save.event.directory")
              : t("eventDirectory:create.event.directory")}
          </Typography>
        </Container>
        <Typography color="textPrimary" variant="body1">
          {t("eventDirectory:link.events.subtitle")}
        </Typography>
      </Container>
      <Button
        variant="ghost"
        color="textPrimary"
        size="md"
        onClick={handleClose}
        className={styles.closeButton}
        isIconButton
        data-testid="close-button"
      >
        <Close />
      </Button>
    </Container>
  );
};

export default DialogHeader;
